<template>
  <v-layout row>
    <v-flex>
      <v-card>
        <v-list two-line subheader>
          <v-list-tile
            v-for="item in items"
            :key="item.title"
            @click="rowClicked(item.link)"
          >
            <v-list-tile-avatar>
              <v-icon>assignments</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.nume }}</v-list-tile-title>
              <!-- <v-list-tile-sub-title>{{ item.link }}</v-list-tile-sub-title> -->
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import myApiInstance from '../APIService'

export default {
  name: 'RaportWidget',
  props: {
    queryId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      items: []
    }
  },
  created: function() {
    this.getReport()
  },
  methods: {
    getReport() {
      myApiInstance
        .getQueryData(this.queryId)
        .then((res) => {
          this.items = res.data
        })
        .catch(function(error) {
          console.log('Error', error)
        })
    },
    rowClicked(event) {
      window.open(event, '_blank')
    }
  }
}
</script>
